// Actions
const SET = 'isFramed/SET';

// Reducer
function reducer(state = {}, action = {}) {
  switch (action.type) {
    case SET:
      // Perform action
      return {
        ...state,
        isFramed: action.isFramed
      };
    default: return state;
  }
}

// Action Creators
function checkIsFramed() {
  return { type: SET, isFramed: (window !== window.top) };
}

export const isFramed = {
  reducer,
  actions: {
    checkIsFramed
  }
}
